import { render, staticRenderFns } from "./BtnRecibos.vue?vue&type=template&id=3c1ccabc&"
import script from "./BtnRecibos.vue?vue&type=script&lang=js&"
export * from "./BtnRecibos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports